// removed by extract-text-webpack-plugin
module.exports = {"root":"_2knKeuFH3zQZGhM6-RnuEm"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"/"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-44867c35","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"data":"/n    @import '~@/scss/auto-import';/n  ","sourceMap":true}!./src/components/initializer/color-picker/ColorPicker.scss
// module id = 720
// module chunks = 1